<template>
  <span class="chat-avatar-wrap" :style="{ width: `${size}px`, height: `${size}px` }">
    <span v-if="kind === 'channel'" class="chat-avatar channel" :style="box" :title="name"><i class="pi pi-hashtag"></i></span>
    <span v-else-if="kind === 'group'" :class="['chat-avatar', 'group', `tint-${tint}`]" :style="box" :title="name">{{ initials }}</span>
    <span v-else class="chat-avatar person" :style="box" :title="name">
      <img v-if="photoUrl && !imageFailed" :src="photoUrl" :alt="name" @error="imageFailed = true" />
      <span v-else>{{ initials }}</span>
    </span>
    <span v-if="showOnline && kind === 'person' && isOnline" class="chat-online-dot" title="Online"></span>
  </span>
</template>

<script>
import { STORAGE_URL, PROFILE_PICTURES_DIR } from '@/utils/const';
import { conversationTitle, employeeDisplayName, employeeInitials, nameInitials, tintFor } from '@/utils/chat';

/** Avatar for a person, a group (tinted initials) or the organization channel (#). */
export default {
  name: 'ChatAvatar',
  props: {
    conversation: { type: Object, default: null },
    employee: { type: Object, default: null },
    size: { type: Number, default: 36 },
    showOnline: { type: Boolean, default: false },
  },
  data() {
    return { imageFailed: false };
  },
  computed: {
    kind() {
      if (this.employee) return 'person';
      if (this.conversation?.type === 'channel') return 'channel';
      if (this.conversation?.type === 'group') return 'group';
      return 'person';
    },
    person() {
      return this.employee ?? this.conversation?.peer ?? null;
    },
    name() {
      return this.kind === 'person' ? employeeDisplayName(this.person) : conversationTitle(this.conversation);
    },
    initials() {
      return this.kind === 'person' ? employeeInitials(this.person) : nameInitials(this.conversation?.name);
    },
    tint() {
      return tintFor(this.conversation?.id ?? this.conversation?.name);
    },
    photoUrl() {
      const photo = this.person?.profilePhoto;
      return photo ? `${STORAGE_URL}/${PROFILE_PICTURES_DIR}/${photo}` : null;
    },
    isOnline() {
      return this.$store.getters.chatIsOnline(this.person?.id);
    },
    box() {
      return { width: `${this.size}px`, height: `${this.size}px`, fontSize: `${Math.max(10, Math.round(this.size * 0.38))}px` };
    },
  },
  watch: {
    photoUrl() {
      this.imageFailed = false;
    },
  },
};
</script>
